var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-banner',{attrs:{"single-line":""},scopedSlots:_vm._u([{key:"actions",fn:function(ref){
var dismiss = ref.dismiss;
return [_c('v-btn',{attrs:{"icon":"","text":"","color":"#2f598b"},on:{"click":dismiss}},[_c('v-icon',[_vm._v("mdi-close")])],1)]}}])},[_c('v-icon',{attrs:{"slot":"icon","color":"#2f598b","size":"36"},slot:"icon"},[_vm._v("mdi-information")]),_vm._v(" "+_vm._s(_vm.mensagem)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }